import React, { useState, useEffect } from "react";
import { Button, Card, Form, Container, Col } from "react-bootstrap";
import { FormHelper } from "utils";
import useExceptionHandler from "hooks/useExceptionHandler";
import useMessage from "hooks/useMessage";
import { useTheme } from "hooks";
import { AuthenticationManager } from "managers";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";

export const ForgotPasswordPage = ({
  showLoading,
  hideLoading,
  setIsForgotPassword,
}) => {
  const { theme } = useTheme();
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [form, setForm] = useState({
    email: "",
    codigoCompania: "",
  });
  const { handleException } = useExceptionHandler();
  const { Message, Warning, cerrarAlertas } = useMessage();

  useEffect(() => {
    return () => {
      cerrarAlertas();
    };
  });

  const onInputChange = (e) => {
    FormHelper.handleChange(e, setForm);
  };

  const onSubmit = (e) => {
    showLoading();
    FormHelper.handleSubmit(e);
    AuthenticationManager.sendRecoveryEmail(form)
      .then((res) => {
        Message({ message: `Correo de recuperación enviado Exitosamente` });
      })
      .catch((e) => {
        handleException(e);
      })
      .finally(() => {
        hideLoading();
      });
  };

  React.useEffect(() => {
    setTimeout(function () {
      setCardClasses("");
    }, 500);
  }, []);

  return (
    <>
      <div className="full-page section-image" data-color="black">
        <div className="content d-flex align-items-center p-0">
          <Container style={{ maxWidth: "65%", minWidth: "65%" }}>
            <Col className="mx-auto" md="4">
              <Form className="form" onSubmit={onSubmit}>
                <Card className={"card-login " + cardClasses} style={{}}>
                  <Card.Header className="text-center" style={{}}>
                    {theme.logo ? (
                      <img
                        alt="logo"
                        src={theme.logo}
                        height={theme.title == "Citrus ECF" ? "80px" : "72px"}
                        width={theme.title == "Citrus ECF" ? "110px" : "200px"}
                      />
                    ) : (
                      theme.appName
                    )}
                  </Card.Header>
                  <Card.Body
                    className="d-flex"
                    style={{
                      flexDirection: "column",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Form.Group>
                      <label>Correo Electrónico</label>
                      <Form.Control
                        name="email"
                        type="text"
                        value={form.email}
                        onChange={onInputChange}
                      />
                    </Form.Group>
                    <Form.Group>
                      <label>Código Compañía</label>
                      <Form.Control
                        name="Codigo"
                        type="text"
                        value={form.Codigo}
                        onChange={onInputChange}
                      />
                    </Form.Group>
                  </Card.Body>
                  <Card.Footer
                    className="d-flex"
                    style={{ justifyContent: "space-around" }}
                  >
                    <AnimatedIconButton
                      size="60px"
                      height="35px"
                      width="35px"
                      iconName="lock"
                      message="Proceder"
                      onClick={(e) => onSubmit(e)}
                      useVendorTheme={true}
                    />

                    <AnimatedIconButton
                      size="60px"
                      height="35px"
                      width="35px"
                      iconName="x-mark"
                      message="Desestimar"
                      onClick={() => {
                        setIsForgotPassword(false);
                      }}
                      useVendorTheme={true}
                    />
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
      </div>
    </>
  );
};
